import React, { useEffect, useState } from 'react';

const NewContent = () => {
  const [html, setHtml] = useState('');

  useEffect(() => {
    fetch('/new-content.html')
      .then(response => response.text())
      .then(data => {
        setHtml(data);
      })
      .catch(error => console.warn(error));
  }, []);

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default NewContent;
